import React, {Component} from "react";
import PropTypes from 'prop-types';

import {XDiv, XI, XSpan} from "../Layout/Layout";
import {FormManagerContext} from "../Form/FormManagerContext";
import PersianDate from "./PersianDate";

const _shanbeh = "شنبه";
const _dayName = [_shanbeh, 'یک' + _shanbeh, 'دو' + _shanbeh,
    'سه ' + _shanbeh, 'چهار' + _shanbeh,'پنج ' + _shanbeh, 'جمعه'];
const _monthName = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

class    Calendar extends Component{

    constructor(props) {
        super(props);

        this.numberKey=0;
        this.state = {panel:"days"};

        this.HswitchClick = this.switchClick.bind(this);
        this.HnextMonthClick = this.nextMonthClick.bind(this);
        this.HpreviousMonthClick = this.previousMonthClick.bind(this);

        this.HselectDate = this.selectDate.bind(this);
        this.HshowPanel = this.showPanel.bind(this);
        this.HshowDays = this.showDays.bind(this);
        this.HshowMonths = this.showMonths.bind(this);
        this.HshowYears = this.showYears.bind(this);
        this.HshowDecades = this.showDecades.bind(this);

        this.HswitchMonthsClick = this.switchMonthsClick.bind(this);
        this.HnextYearClick = this.nextYearClick.bind(this);
        this.HpreviousYearClick = this.previousYearClick.bind(this);

        this.HswitchDecadesClick = this.switchDecadesClick.bind(this);
        this.HnextDecadesClick = this.nextDecadesClick.bind(this);
        this.HpreviousDecadesClick = this.previousDecadesClick.bind(this);

        this.HnextCenturiesClick = this.nextCenturiesClick.bind(this);
        this.HpreviousCenturiesClick = this.previousCenturiesClick.bind(this);

        this.pd=new PersianDate();

        this.currentDate=props.currentDate;
        if(!this.pd.check(this.currentDate)) {
            this.currentDate=this.pd.getCurrent();
        }

        this._date=props.date;
        if(!this.pd.check(this._date)) {
            this._date=this.currentDate;
        }

        this._y=0;
        this._m=0;
        this._d=0;

        this.childDays=[];
        this.childMonths=[];
        this.childYears=[];
        this.childDecades=[];

        this.switchDate="";
        this.nextMonthDate="";
        this.switchDate="";

        this.switchMonthsDate="";
        this.nextYearDate="";
        this.previousYearDate="";

        this.switchDecadesDate="";
        this.nextDecadesDate="";
        this.previousDecadesDate="";

        this.nextCenturiesDate="";
        this.previousCenturiesDate="";

        this.switchText="";
        this.switchMonths="";
        this.switchDecades="";

        this.props=props;

    }

    setDate(date) {
        if(this.pd.check(date)) {
            this.HshowPanel("days", date);
        }else{
            this.HshowPanel("days", this.currentDate);
        }
    }


    getDate() {
        return this._date;
    }

    componentDidMount() {
        this.HshowPanel("days",this._date);
    }

    switchClick(){
        this.HshowPanel("months",this.switchDate);
    }

    nextMonthClick(){
        this.HshowPanel("days",this.nextMonthDate);
    }

    previousMonthClick(){
        this.HshowPanel("days",this.previousMonthDate);
    }

    selectDate (date) {
        if(this.pd.check(date)) {
            this._date = date;
            let dateArray = this._date.split('/');
            this._y=parseInt(dateArray[0]);
            this._m=parseInt(dateArray[1]);
            this._d=parseInt(dateArray[2]);
            this.HshowDays();
            let f = this.props.selectCallback;
            if (f !== null) {
                if (f instanceof Function) {
                    f();
                }
            }
        }
    };

    showDays (){
        this.childDays=[];

        let date=this._date;
        let dateArray = date.split('/');
        let y=parseInt(dateArray[0]);
        let m=parseInt(dateArray[1]);
        //let d=parseInt(dateArray[2]);

        let str=y+"/"+m+"/01";
        let weekDay = this.pd.getWeekDay(str);

        let pmDate=this.pd.previousMonth(date);
        let dateArrayPrevious = pmDate.split('/');
        let yPrevious=parseInt(dateArrayPrevious[0]);
        let mPrevious=parseInt(dateArrayPrevious[1]);
        let nmDate=this.pd.nextMonth(date);
        let dateArrayNext = nmDate.split('/');
        let yNext=parseInt(dateArrayNext[0]);
        let mNext=parseInt(dateArrayNext[1]);

        this.switchText=_monthName[m-1] +" "+y;

        this.switchDate=date;
        this.nextMonthDate=nmDate;
        this.previousMonthDate=pmDate;

        let pmday=this.pd.getMonthDays(pmDate);
        let mday=this.pd.getMonthDays(date);

        for (let row = 0; row < 6; row++) {
            let items=[];
            for (let col = 0; col < 7; col++) {
                let cellValue = row * 7 + col - weekDay + 1;
                let s1;
                let cs;
                let sDate;
                this.numberKey++;
                if (cellValue <= 0){
                    cellValue+=pmday;
                    sDate=yPrevious+"/"+mPrevious+"/"+cellValue;
                    cs="day old";
                    if(col===6) cs=cs+' friday' ;
                    s1=<XSpan key={this.numberKey} className={cs} onClick={(evt) => this.HselectDate(sDate, evt)}>{cellValue}</XSpan>;
                    items.push(s1);
                }else
                if (cellValue <=mday ) {
                    cs="day";
                    if(col===6) cs=cs+' friday' ;
                    if(y===this._y && m===this._m && cellValue===this._d) cs=cs+' select' ;
                    sDate=y+"/"+m+"/"+cellValue;
                    s1=<XSpan key={this.numberKey} className={cs} onClick={(evt) => this.HselectDate(sDate, evt)}>{cellValue}</XSpan>;
                    items.push(s1);
                }else{
                    cellValue-=mday;
                    cs="day new";
                    if(col===6) cs=cs+' friday' ;
                    sDate=yNext+"/"+mNext+"/"+cellValue;
                    s1=<XSpan key={this.numberKey} className={cs} onClick={(evt) => this.HselectDate(sDate, evt)}>{cellValue}</XSpan>;
                    items.push(s1);
                }
            }
            this.numberKey++;
            let divRow=<XDiv key={this.numberKey} className="row-days">{items}</XDiv>;
            this.childDays.push(divRow);
        }
    };

    switchMonthsClick(){
        this.HshowPanel("years",this.switchMonthsDate);
    }

    nextYearClick(){
        this.HshowPanel("months",this.nextYearDate);
    }

    previousYearClick(){
        this.HshowPanel("months",this.previousYearDate);
    }

    showMonths () {
        this.childMonths=[];

        let date=this._date;
        let dateArray = date.split('/');
        let y=parseInt(dateArray[0]);
        //let m=parseInt(dateArray[1]);
        let d=parseInt(dateArray[2]);

        let pyDate=this.pd.previousYear(date);
        let nyDate=this.pd.nextYear(date);

        this.switchMonths=y;
        this.switchMonthsDate=date;
        this.nextYearDate=nyDate;
        this.previousYearDate=pyDate;
        for (let row = 0; row < 4; row++) {
            let items=[];
            for (let col = 0; col < 3; col++) {
                let c = row * 3 + col ;
                let sDate=y+"/"+(c+1)+"/"+d;
                let cs="month";
                if(y===this._y && (c+1)===this._m)  cs=cs+' focused' ;
                this.numberKey++;
                let s1=<XSpan key={this.numberKey} className={cs} onClick={(evt) => this.HshowPanel("days",sDate)}>{_monthName[c]}</XSpan>;
                items.push(s1);
            }
            this.numberKey++;
            let divRow=<XDiv key={this.numberKey} className="row-month">{items}</XDiv>;
            this.childMonths.push(divRow);
        }
    };

    switchDecadesClick(){
        this.HshowPanel("decades",this.switchDecadesDate);
    }

    nextDecadesClick(){
        this.HshowPanel("years",this.nextDecadesDate);
    }

    previousDecadesClick(){
        this.HshowPanel("years",this.previousDecadesDate);
    }

    showYears () {
        this.childYears=[];

        let date=this._date;
        let dateArray = date.split('/');
        let y=parseInt(dateArray[0]);
        let m=parseInt(dateArray[1]);
        let d=parseInt(dateArray[2]);

        let f=Math.floor(y/10);
        let f_s=f*10;
        let f_e=(f+1)*10;
        let decade=f_s+"-"+f_e;

        let pdecDate=this.pd.previousYear(date,10);
        let ndecDate=this.pd.nextYear(date,10);

        this.switchDecades=decade;
        this.switchDecadesDate=date;
        this.nextDecadesDate=ndecDate;
        this.previousDecadesDate=pdecDate;
        for (let row = 0; row < 5; row++) {
            let items=[];
            for (let col = 0; col < 3; col++) {
                let c = row * 3 + col+f_s-3 ;
                let sDate=c+"/"+m+"/"+d;
                let cs="year";
                if(c<f_s){
                    cs=cs+' old' ;
                }else
                if(c>=f_e){
                    cs=cs+' new' ;
                }
                if(c===this._y )  cs=cs+' focused' ;
                this.numberKey++;
                let s1=<XSpan key={this.numberKey} className={cs} onClick={(evt) => this.HshowPanel("months",sDate)}>{c}</XSpan>;
                items.push(s1);
            }

            this.numberKey++;
            let divRow=<XDiv key={this.numberKey} className="row-year">{items}</XDiv>;
            this.childYears.push(divRow);
        }
    };

    nextCenturiesClick(){
        this.HshowPanel("decades",this.nextCenturiesDate);
    }

    previousCenturiesClick(){
        this.HshowPanel("decades",this.previousCenturiesDate);
    }

    showDecades () {
        this.childDecades=[];

        let date=this._date;
        let dateArray = date.split('/');
        let y=parseInt(dateArray[0]);
        let m=parseInt(dateArray[1]);
        let d=parseInt(dateArray[2]);

        let f=Math.floor(y/100);
        let f_s=f*100;
        let f_e=(f+1)*100;
        let centuries=f_s+"-"+f_e;

        let pcenDate=this.pd.previousYear(date,100);
        let ncenDate=this.pd.nextYear(date,100);

        this.switchCenturies=centuries;
        this.nextCenturiesDate=ncenDate;
        this.previousCenturiesDate=pcenDate;
        let _c_y=Math.floor(this._y/10)*10;
        for (let row = 0; row < 5; row++) {
            let items=[];
            for (let col = 0; col < 3; col++) {
                let c = (row * 3 + col)*10+f_s -30;
                let sDate=(c+7)+"/"+m+"/"+d;
                let cs="decade";
                if(c<f_s){
                    cs=cs+' old' ;
                }else
                if(c>=f_e){
                    cs=cs+' new' ;
                }
                if(c=== _c_y) cs=cs+' focused' ;
                this.numberKey++;
                let s1=<XSpan key={this.numberKey} className={cs} onClick={(evt) => this.HshowPanel("years",sDate)}>{c}</XSpan>;
                items.push(s1);
            }
            this.numberKey++;
            let divRow=<XDiv key={this.numberKey} className="row-decade">{items}</XDiv>;
            this.childDecades.push(divRow);
        }
    };

    showPanel(panel,date){
        if(this.pd.check(date)) {
            this.childDays=[];
            this.childMonths=[];
            this.childYears=[];
            this.childDecades=[];
            this._date = date;
            switch (panel) {
                case "months":
                    this.HshowMonths();
                    break;
                case "years":
                    this.HshowYears();
                    break;
                case "decades":
                    this.HshowDecades();
                    break;
                default:
                case "days":
                    this.HshowDays();
                    break;
            }
            this.setState({panel:panel});
        }
    }

    render() {

        let cD="days";
        let cM="months";
        let cY="years";
        let cDe="decades";

        switch (this.state.panel) {
            case "months":
                cM=cM+" show";
                break;
            case "years":
                cY=cY+" show";
                break;
            case "decades":
                cDe=cDe+" show";
                break;
            default:
            case "days":
                cD=cD+" show";
                break;
        }


        return (
            <React.Fragment>
                <XDiv className="calendar">
                    <XDiv className={cD}>
                        <XDiv className="header">
                            <XSpan className="switch"  onClick={this.HswitchClick} >{ this.switchText }</XSpan>
                            <XSpan className="next"  onClick={this.HnextMonthClick} ><XI  className='la la-angle-double-right'/></XSpan>
                            <XSpan className="previous" onClick={this.HpreviousMonthClick}  ><XI  className='la la-angle-double-left'/></XSpan>
                        </XDiv>
                        <XDiv className="days-name">
                            <XSpan className="name"   >{ _dayName[0] }</XSpan>
                            <XSpan className="name"   >{ _dayName[1] }</XSpan>
                            <XSpan className="name"   >{ _dayName[2] }</XSpan>
                            <XSpan className="name"   >{ _dayName[3] }</XSpan>
                            <XSpan className="name"   >{ _dayName[4] }</XSpan>
                            <XSpan className="name"   >{ _dayName[5] }</XSpan>
                            <XSpan className="name"   >{ _dayName[6] }</XSpan>
                        </XDiv>
                        {this.childDays}
                    </XDiv>
                    <XDiv className={cM}>
                        <XDiv className="header">
                            <XSpan className="switch"  onClick={this.HswitchMonthsClick} >{ this.switchMonths }</XSpan>
                            <XSpan className="next"  onClick={this.HnextYearClick} ><XI  className='la la-angle-double-right'/></XSpan>
                            <XSpan className="previous" onClick={this.HpreviousYearClick}  ><XI  className='la la-angle-double-left'/></XSpan>
                        </XDiv>
                        {this.childMonths}
                    </XDiv>
                    <XDiv className={cY}>
                        <XDiv className="header">
                            <XSpan className="switch"  onClick={this.HswitchDecadesClick} >{ this.switchDecades }</XSpan>
                            <XSpan className="next"  onClick={this.HnextDecadesClick} ><XI  className='la la-angle-double-right'/></XSpan>
                            <XSpan className="previous" onClick={this.HpreviousDecadesClick}  ><XI  className='la la-angle-double-left'/></XSpan>
                        </XDiv>
                        {this.childYears}
                    </XDiv>
                    <XDiv className={cDe}>
                        <XDiv className="header">
                            <XSpan className="switch"  >{ this.switchCenturies }</XSpan>
                            <XSpan className="next"  onClick={this.HnextCenturiesClick} ><XI  className='la la-angle-double-right'/></XSpan>
                            <XSpan className="previous" onClick={this.HpreviousCenturiesClick}  ><XI  className='la la-angle-double-left'/></XSpan>
                        </XDiv>
                        {this.childDecades}
                    </XDiv>
                </XDiv>
            </React.Fragment>
        )
    }
}

Calendar.propTypes = {
    selectCallback: PropTypes.func,
    currentDate: PropTypes.string,
    date: PropTypes.string,
    local: PropTypes.string,
};

Calendar.defaultProps = {
    currentDate:'',
    date:'',
    local:'fa',
};

Calendar.contextType = FormManagerContext;

export default Calendar;
